import { render, staticRenderFns } from "./MarkdownComponent.vue?vue&type=template&id=3100e564"
import script from "./MarkdownComponent.vue?vue&type=script&lang=js"
export * from "./MarkdownComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3100e564')) {
      api.createRecord('3100e564', component.options)
    } else {
      api.reload('3100e564', component.options)
    }
    module.hot.accept("./MarkdownComponent.vue?vue&type=template&id=3100e564", function () {
      api.rerender('3100e564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/markdown-component/MarkdownComponent.vue"
export default component.exports